import { useEffect, useState } from "react";
import { useAuth } from "@/lib/auth";
import { api } from "@/lib/api";
import { formatIST } from "@/lib/dates";
import { Link } from "react-router-dom";
import { Camera, MapPin, Clock, AirplaneTilt } from "@phosphor-icons/react";

export default function StaffHome() {
  const { user } = useAuth();
  const [today, setToday] = useState(null);

  useEffect(() => { api.get("/attendance/today").then((r) => setToday(r.data)); }, []);

  return (
    <div className="px-5 pt-6 pb-12 max-w-md mx-auto">
      <p className="text-xs tracking-[0.3em] uppercase text-[#E50914]">{new Date().toLocaleDateString(undefined, { weekday:"long" })}</p>
      <h1 className="font-display text-4xl tracking-tight mt-1">Hi, {user?.name?.split(" ")[0]}.</h1>
      <p className="text-sm text-zinc-400 mt-1 font-mono">{user?.employee_id} · {user?.shift}</p>

      <div className="mt-6 bg-[#16161C] border border-[#2D2D35] rounded-md p-5">
        <div className="flex items-center justify-between">
          <div className="text-xs tracking-[0.2em] uppercase text-zinc-500">Today's Punch</div>
          <span className={`text-[10px] px-2 py-1 rounded ${today?.in_at ? "bg-[#22C55E]/15 text-[#22C55E]" : "bg-zinc-700/40 text-zinc-400"}`}>
            {today?.in_at ? "Clocked In" : "Not yet"}
          </span>
        </div>
        <div className="mt-4 grid grid-cols-2 gap-4">
          <div>
            <div className="text-[10px] uppercase tracking-widest text-zinc-500">IN</div>
            <div className="font-mono text-2xl mt-1">{formatIST(today?.in_at, "short")}</div>
          </div>
          <div>
            <div className="text-[10px] uppercase tracking-widest text-zinc-500">OUT</div>
            <div className="font-mono text-2xl mt-1">{formatIST(today?.out_at, "short")}</div>
          </div>
        </div>
        {today?.computed && (
          <div className="mt-4 flex items-center gap-4 text-xs text-zinc-400">
            <div>Worked: <span className="font-mono text-white">{today.computed.worked_hours}h</span></div>
            <div>Late: <span className="font-mono text-[#F59E0B]">{today.computed.late_minutes}m</span></div>
          </div>
        )}
      </div>

      <Link to="/punch" data-testid="staff-cta-punch"
            className="mt-6 block bg-[#E50914] hover:bg-[#C80812] text-white rounded-md p-6 transition-colors duration-200 pulse-red">
        <div className="flex items-center justify-between">
          <div>
            <div className="text-[10px] uppercase tracking-[0.3em] opacity-80">Action</div>
            <div className="font-display text-2xl mt-1">{today?.in_at ? "Punch OUT" : "Punch IN"}</div>
            <div className="text-xs mt-1 opacity-80">Live selfie · GPS · Watermarked</div>
          </div>
          <Camera size={42} weight="bold" />
        </div>
      </Link>

      <div className="mt-6 grid grid-cols-2 gap-3">
        <Link to="/my-leave" className="bg-[#16161C] border border-[#2D2D35] rounded-md p-4 hover:bg-[#1C1C24] transition-colors">
          <AirplaneTilt size={22} className="text-[#E50914]" />
          <div className="mt-2 text-sm">Apply Leave</div>
        </Link>
        <Link to="/my-payslips" className="bg-[#16161C] border border-[#2D2D35] rounded-md p-4 hover:bg-[#1C1C24] transition-colors">
          <Clock size={22} className="text-[#E50914]" />
          <div className="mt-2 text-sm">My Salary</div>
        </Link>
      </div>
    </div>
  );
}
